var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{class:['bo-dropdown-menu', _vm.dropdownStyle],attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.valueId},on:{"input":_vm.onInput}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id,domProps:{"value":option.id}},[_vm._v(_vm._s(option.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }